import { render, staticRenderFns } from "./enterpriseScience.vue?vue&type=template&id=98a32eae&scoped=true"
import script from "./enterpriseScience.vue?vue&type=script&lang=js"
export * from "./enterpriseScience.vue?vue&type=script&lang=js"
import style0 from "./enterpriseScience.vue?vue&type=style&index=0&id=98a32eae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a32eae",
  null
  
)

export default component.exports